import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "ml-1"
};
import PlayerList from "@/modules/team/components/PlayerList.vue";
import Vars from "@/modules/vue/components/Vars.vue";
import { TransferOfferStatusEnum } from "@/modules/transfer-market/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'ListingTable',
  props: {
    listings: null
  },
  emits: ['click-create-offer'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const mapping = computed(() => collect(props.listings).mapWithKeys(listing => [listing.player.id, listing]).all());
    const onClickCreateOffer = listing => emit('click-create-offer', listing);
    const router = useRouter();
    const goToListing = listing => router.push({
      name: 'transfer-market.team-offers.show',
      params: {
        id: listing.offers[0].id
      }
    });
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(PlayerList, {
        players: __props.listings.map(i => i.player),
        "show-market-value": "",
        "show-talent": ""
      }, {
        action: _withCtx(({
          player
        }) => [_createVNode(Vars, {
          listing: _unref(mapping)[player.id],
          firstOffer: _unref(mapping)[player.id].offers[0]
        }, {
          default: _withCtx(({
            listing,
            firstOffer
          }) => [_createElementVNode("div", null, _toDisplayString(_ctx.$money(listing.price)), 1), _createElementVNode("div", _hoisted_1, [listing.offers.length === 0 ? (_openBlock(), _createBlock(_component_NButton, {
            key: 0,
            secondary: "",
            size: "small",
            onClick: $event => onClickCreateOffer(listing)
          }, {
            default: _withCtx(() => [_createVNode(_component_Icon, {
              icon: _ctx.IconEnum.Handshake20Regular
            }, null, 8, ["icon"])]),
            _: 2
          }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_NButton, {
            key: 1,
            secondary: "",
            type: firstOffer.status === _unref(TransferOfferStatusEnum).FAILED ? 'error' : 'success',
            size: "small",
            onClick: $event => goToListing(listing)
          }, {
            default: _withCtx(() => [_createVNode(_component_Icon, {
              icon: _ctx.IconEnum.Handshake20Regular
            }, null, 8, ["icon"])]),
            _: 2
          }, 1032, ["type", "onClick"]))])]),
          _: 2
        }, 1032, ["listing", "firstOffer"])]),
        _: 1
      }, 8, ["players"]);
    };
  }
});